"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudiencePickerProvider = void 0;
var _react = require("react");
var _hooks = require("./hooks");
var _hooks2 = require("../../../hooks");
var _urls = require("../../../utilities/urls");
var _AudiencePickerProvider = require("./AudiencePickerProvider.helpers");
const emptyArray = [];
const useAudiencePickerProvider = props => {
  const {
    teacherIds = emptyArray,
    schoolId = null,
    environmentID = null,
    audienceID = null,
    isReadOnly = false,
    readOnlyGroups = emptyArray,
    readOnlyStudents = emptyArray,
    selectedGroups = emptyArray,
    selectedStudents = emptyArray,
    onClose = null,
    onDisableItemClick = null,
    onDeleteItem = null,
    onChanged = null,
    fullHeight
  } = props;
  const {
    isSessionDataReady,
    userId,
    role,
    schoolId: sessionSchoolId
  } = (0, _hooks2.useSessionData)();
  const {
    sendUiUsageEvent
  } = (0, _hooks2.useCetEvents)();
  const [isAudiencePickerProviderReady, setIsAudiencePickerProviderReady] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [audienceData, setAudienceData] = (0, _react.useState)(null);
  const [groupsMapper, setGroupsMapper] = (0, _react.useState)(null);
  const [classesMapper, setClassesMapper] = (0, _react.useState)(null);
  const [singleStudentsMapper, setSingleStudentsMapper] = (0, _react.useState)(null);
  const [studentsMapper, setStudentsMapper] = (0, _react.useState)(null);
  const [groupsIds, setGroupsIds] = (0, _react.useState)([]);
  const [classesIds, setClassesIds] = (0, _react.useState)([]);
  const [singleStudentsIds, setSingleStudentsIds] = (0, _react.useState)([]);
  const [studentsIds, setStudentsIds] = (0, _react.useState)([]);
  const [isNoAudience, setIsNoAudience] = (0, _react.useState)(false);
  const [groupType, setGroupType] = (0, _react.useState)('classes');
  const [createGroupErrorMessage, setCreateGroupErrorMessage] = (0, _react.useState)('create_group_error_title');
  const [cantRemoveMessage, setCantRemoveMessage] = (0, _react.useState)('');
  const {
    view,
    viewIndex,
    setViewAndIndex,
    isErrorMessage
  } = (0, _hooks.useView)();
  const {
    readOnlyGroupsMapper,
    readOnlyStudentsMapper
  } = (0, _hooks.useReadOnly)(readOnlyGroups, readOnlyStudents);
  const {
    originalSelectedGroupsIds,
    originalSelectedClassesIds,
    originalSelectedStudentsIds,
    selectedGroupsIds,
    setSelectedGroupsIds,
    selectedClassesIds,
    selectedStudentsIds,
    setSelectedStudentsIds,
    getSelectedGroupsAndStudentsData,
    onSelectedChanged
  } = (0, _hooks.useSelected)(selectedGroups, selectedStudents, classesMapper, groupsMapper, studentsMapper, onChanged);
  const {
    groupsSelectorTempData,
    setGroupsSelectorTempData,
    studentsSelectorTempData,
    setStudentsSelectorTempData,
    createGroupTempData,
    setCreateGroupTempData,
    getStudentsSearchList
  } = (0, _hooks.useTempData)(studentsIds, singleStudentsIds, classesMapper, groupsMapper, studentsMapper);
  const userIds = (0, _react.useMemo)(() => isSessionDataReady && userId && role && ['teacher', 'coordinator', 'admin'].indexOf(role) >= 0 ? teacherIds?.length > 0 ? [...teacherIds] : [userId] : [], [isSessionDataReady, role, teacherIds, userId]);
  const itemSchoolId = (0, _react.useMemo)(() => isSessionDataReady && userId && role && ['teacher', 'coordinator', 'admin'].indexOf(role) >= 0 ? schoolId || sessionSchoolId : null, [isSessionDataReady, role, schoolId, sessionSchoolId, userId]);
  (0, _react.useEffect)(() => {
    if (userIds && userIds.length > 0 && itemSchoolId) {
      let mappers = {
        groups: {},
        classes: {},
        singleStudents: {},
        students: {}
      };
      setIsLoading(true);
      Promise.all(userIds.map(userId => fetch(`${_urls.ofakimApiUrl}/lmscp/getTeacherGroupsAndStudents?schoolID=${itemSchoolId}&userID=${userId}&environmentID=${environmentID}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        referrerPolicy: 'no-referrer',
        credentials: 'include',
        redirect: 'follow'
      }).then(response => response.json()).then(groups => groups && groups.value && groups.value.length > 0 ? groups.value : []).then(groups => {
        if (audienceID) {
          setAudienceData((0, _AudiencePickerProvider.getAudienceData)(groups, audienceID));
        }
        groups.forEach(group => {
          (0, _AudiencePickerProvider.mapClassesAndGroups)(group, userId, mappers);
          if (group.students?.length > 0) {
            (0, _AudiencePickerProvider.mapStudents)(group, mappers);
            (0, _AudiencePickerProvider.sortClassesAndGroupsStudents)(group, mappers);
          }
        });
        return {
          userId: userId,
          groups: groups
        };
      }).catch(error => {
        console.error(error);
        return {
          userId: userId,
          groups: []
        };
      }))).then(() => {
        setClassesMapper(mappers.classes);
        setGroupsMapper(mappers.groups);
        setSingleStudentsMapper(mappers.singleStudents);
        setStudentsMapper(mappers.students);
        setClassesIds((0, _AudiencePickerProvider.sortByGroupName)(mappers.classes));
        setGroupsIds((0, _AudiencePickerProvider.sortByGroupName)(mappers.groups));
        setSingleStudentsIds((0, _AudiencePickerProvider.sortByStudentFullName)(mappers.singleStudents));
        setStudentsIds((0, _AudiencePickerProvider.sortByStudentFullName)(mappers.students));
        setIsAudiencePickerProviderReady(true);
        setIsLoading(false);
      });
    } else {
      setClassesMapper(null);
      setGroupsMapper(null);
      setSingleStudentsMapper(null);
      setStudentsMapper(null);
      setClassesIds([]);
      setGroupsIds([]);
      setSingleStudentsIds([]);
      setStudentsIds([]);
      setIsAudiencePickerProviderReady(false);
      setIsLoading(false);
    }
  }, [audienceID, environmentID, itemSchoolId, userIds]);
  (0, _react.useEffect)(() => {
    if (isAudiencePickerProviderReady) {
      setIsNoAudience(classesIds?.length === 0 && groupsIds?.length === 0 && studentsIds?.length === 0);
    }
  }, [classesIds, classesIds?.length, groupsIds, groupsIds?.length, isAudiencePickerProviderReady, studentsIds, studentsIds?.length]);
  (0, _react.useEffect)(() => {
    let newGroupType = groupType;
    if (groupType === 'classes' && !(classesIds?.length > 0) && groupsIds?.length > 0) {
      newGroupType = 'groups';
    } else if (groupType === 'groups' && !(groupsIds?.length > 0) && classesIds?.length > 0) {
      newGroupType = 'classes';
    }
    if (newGroupType !== groupType) {
      setGroupType(newGroupType);
    }
  }, [classesIds?.length, groupType, groupsIds?.length]);
  const saveGroup = (0, _react.useCallback)(function (goToView, goToViewIndex, goToErrorView, goToErrorViewIndex) {
    let isSelected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const promise = new Promise((resolve, reject) => {
      if (itemSchoolId && userIds?.length > 0 && studentsSelectorTempData.selectedStudentsIds && studentsSelectorTempData.selectedStudentsIds.length > 0 && createGroupTempData.groupName) {
        fetch(`${_urls.ofakimApiUrl}/lmscp/createGroup`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          referrerPolicy: 'no-referrer',
          credentials: 'include',
          redirect: 'follow',
          body: JSON.stringify({
            schoolID: itemSchoolId,
            groupName: createGroupTempData.groupName,
            studentIDs: studentsSelectorTempData.selectedStudentsIds,
            teacherIDs: userIds
          })
        }).then(response => response.json()).then(group => {
          const value = group && group.value;
          if (value) {
            if (audienceID) {
              audienceData?.Groups.push(value.id);
              fetch(`${_urls.ofakimApiUrl}/lmscp/upsertAudience`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                  'Content-Type': 'application/json'
                },
                referrerPolicy: 'no-referrer',
                credentials: 'include',
                redirect: 'follow',
                body: JSON.stringify(audienceData)
              }).catch(error => {});
            }
            resolve(value);
          } else {
            reject(group);
          }
        }).catch(error => {
          reject(error);
        });
      } else {
        reject();
      }
    });
    promise.then(group => {
      sendUiUsageEvent({
        category: 'assignActivity',
        label: 'ConfirmNewGroup'
      });
      let _groupsMapper = (0, _AudiencePickerProvider.updateGroupsMapper)(group, groupsMapper, userIds, studentsSelectorTempData);
      let _studentsMapper = (0, _AudiencePickerProvider.updateStudentsMapper)(group, studentsMapper, _groupsMapper, studentsSelectorTempData);
      setGroupsMapper(_groupsMapper);
      setStudentsMapper(_studentsMapper);
      setGroupsIds((0, _AudiencePickerProvider.sortByGroupName)(_groupsMapper));
      setStudentsIds((0, _AudiencePickerProvider.sortByStudentFullName)(_studentsMapper));
      if (isSelected) {
        if (selectedGroupsIds.indexOf(group.id) < 0) {
          setSelectedGroupsIds([group.id, ...selectedGroupsIds]);
          setSelectedStudentsIds(selectedStudentsIds.filter(id => studentsSelectorTempData.selectedStudentsIds.indexOf(id) < 0));
        }
      }
      setViewAndIndex(goToView, goToViewIndex);
    }).catch(error => {
      const errorMessage = error && error.description === 'Group name already exists' ? 'create_group_name_exists_error_title' : 'create_group_error_title';
      setCreateGroupErrorMessage(errorMessage);
      setViewAndIndex(goToErrorView, goToErrorViewIndex);
    });
  }, [audienceData, audienceID, createGroupTempData.groupName, groupsMapper, itemSchoolId, selectedGroupsIds, selectedStudentsIds, sendUiUsageEvent, setSelectedGroupsIds, setSelectedStudentsIds, setViewAndIndex, studentsMapper, studentsSelectorTempData, userIds]);
  return {
    isAudiencePickerProviderReady,
    isLoading,
    isNoAudience,
    userIds,
    itemSchoolId,
    audienceData,
    environmentID,
    classesMapper,
    groupsMapper,
    studentsMapper,
    singleStudentsMapper,
    groupsIds,
    classesIds,
    singleStudentsIds,
    studentsIds,
    isReadOnly,
    readOnlyGroupsMapper,
    readOnlyStudentsMapper,
    originalSelectedGroupsIds,
    originalSelectedClassesIds,
    originalSelectedStudentsIds,
    selectedGroupsIds,
    selectedClassesIds,
    selectedStudentsIds,
    getSelectedGroupsAndStudentsData,
    onSelectedChanged,
    groupType,
    setGroupType,
    createGroupTempData,
    setCreateGroupTempData,
    groupsSelectorTempData,
    setGroupsSelectorTempData,
    studentsSelectorTempData,
    setStudentsSelectorTempData,
    getStudentsSearchList,
    saveGroup,
    createGroupErrorMessage,
    cantRemoveMessage,
    setCantRemoveMessage,
    view,
    viewIndex,
    setViewAndIndex,
    isErrorMessage,
    onClose,
    onDisableItemClick,
    onDeleteItem,
    fullHeight
  };
};
exports.useAudiencePickerProvider = useAudiencePickerProvider;